import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Notification from 'app/components/general/Notification';
import classnames from 'classnames';
import { parseAmount } from 'app/utils/parsers';

import { Link } from 'react-router-dom';
import Button from 'app/components/general/Button';

import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import MatchesTableSelectable, { IMatchRow } from 'app/components/matches/MatchesTableSelectable';

import _ from 'lodash';
import {
  ITeamsSelector, IPaymentEventsSelector, IOrganisationsSelector, IGroupsSelector,
} from 'app/types/selector';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as groupsActions from 'app/ducks/groups/actions';
import * as teamPaymentRequestsActions from 'app/ducks/teamPaymentRequests/actions';
import * as bulkMatchPaymentsActions from 'app/ducks/bulkMatchPayments/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as bulkMatchPaymentsSelectors from 'app/ducks/bulkMatchPayments/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';

import PaymentCardMin from 'app/components/matches/PaymentCardMin';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    teams: teamsSelectors.getTeams(state),
    organisations: organisationsSelectors.getOrganisations(state),
    bulkMatchPayments: bulkMatchPaymentsSelectors.getBulkMatchPayments(state),
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    groups: groupsSelectors.getGroups(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(paymentEventsActions, teamsActions, groupsActions, teamPaymentRequestsActions, bulkMatchPaymentsActions);

interface ISelectMatchesProps {
  appReady: any;
  teams: ITeamsSelector;
  paymentEvents: IPaymentEventsSelector;
  organisations: IOrganisationsSelector;
  bulkMatchPayments: any;
  teamPaymentRequests: any;
  groups: IGroupsSelector;
  actions: any;
  isLoading: boolean;
  errors: any;
}

interface ISelectMatchesState {
  paymentStatus: any;
  selectedPeopleIds: string[];
  selectedPeopleById: any;
  selectedAllRows: boolean;
  selectedRowIds: string[];
  selectedRows: any;
  matchRows?: {
    [index: string]: IMatchRow;
  };
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class SelectMatches extends React.Component<
ISelectMatchesProps,
ISelectMatchesState
> {
  static defaultProps: ISelectMatchesProps = {
    paymentEvents: {},
    teams: {},
    organisations: {},
    teamPaymentRequests: {},
    groups: {},
    actions: undefined,
    isLoading: false,
    appReady: false,
    errors: {},
  };

  state: ISelectMatchesState = {
    paymentStatus: { id: 'pending', name: 'Unpaid' },
    selectedRows: {},
    selectedAllRows: false,
    selectedRowIds: [],
    matchRows: {},
  };

  componentDidMount = () => {
    this.props.actions.getAllPaymentEventsForAllTeams();
  };

  handleSelectPaymentStatus = (e): void => {
    this.setState({ paymentStatus: e });
  };

  renderPaymentCards = (): React.ReactNode => {
    const paymentCards = paymentEventsSelectors.getPaymentEventsByIdSortedDateFilterByStatus(
      this.props.paymentEvents.paymentEventsById,
      this.props.teams.currentTeam.group.id,
      this.state.paymentStatus.id,
    );
    if (!_.isEmpty(paymentCards)) {
      return _.map(paymentCards, (paymentEvent, key) => {
        const eventData = paymentEventsSelectors.getPaymentEventForMatchCard(
          paymentEvent,
          this.props.teams.currentTeam.group.id,
        );
        if (eventData === undefined) {
          return null;
        }
        return (
          <div className="row with-margin-bottom" key={key}>
            <div className="col">
              <PaymentCardMin {...eventData} />
            </div>
          </div>
        );
      });
    }
    return (
      <div className="text-center with-margin-top">
        <h2 className="text-grey text-weight-medium">There are no matches.</h2>
      </div>
    );
  };

  groupIds = () => {
    const groupIds = [];

    _.each(this.props.teams.teamsById, (t) => {
      _.each(t.groups, (g) => {
        if (!_.isEmpty(g?.id)) {
          groupIds.push({ teamId: t.id, groupId: g?.id });
        }
      });
    });

    return _.uniqBy(groupIds, (u) => u.groupId);
  }

  noConnectedTeams = (): boolean => this.props.teams.hasLoaded && _.isEmpty(this.groupIds());

  hasMultipleTeams = (): boolean => this.props.teams.hasLoaded && this.props.teams.teamIds?.length > 1;

  allRowsSelected = (paymentEventsById, selectedRows): boolean => paymentEventsById.length === selectedRows.length

  updateSelectedRows = (prevState, selectedRows): any => {
    // console.log(prevState);
    // console.log(selectedRows);
    const selectedRowIds = _.keys(_.pickBy(selectedRows, (d) => d));

    return {
      ...prevState,
      selectedRowIds,
      selectedRows,
    };
  }

  selectRow = (ids: string[]): void => {
    this.setState((previousState) => {
      const newState = previousState;
      const selected = previousState.matchRows[ids[0]]?.selected === undefined ? true : !previousState.matchRows[ids[0]]?.selected;

      _.map(ids, (id) => {
        const amount = _.find(this.props.paymentEvents.paymentEventsById, (p) => p.groupOneMatchPayment?.id)?.groupOneMatchPaymentAmount || _.find(this.props.paymentEvents.paymentEventsById, (p) => p.groupTwoMatchPayment?.id)?.groupTwoMatchPaymentAmount;

        newState.matchRows[id] = {
          ...previousState.matchRows[id],
          selected,
          amount,
        };
      });
      const selectedAllRows = this.allRowsSelected(this.props.paymentEvents.paymentEventsById, this.selectedMatchIds(newState.matchRows));

      return {
        changed: true,
        changedSelectedRow: true,
        matchRows: this.calculateRows(previousState, this.selectedMatchIds(newState.matchRows)),
        selectedAllRows,
      };
    });
  };

  calculateRows = (previousState, selectedMatchIds): any => {
    const rows = {};
    const groupOneMatchPaymentIds = _.map(this.props.paymentEvents.paymentEventsById, (p) => p.groupOneMatchPayment?.id);
    const groupTwoMatchPaymentIds = _.map(this.props.paymentEvents.paymentEventsById, (p) => p.groupTwoMatchPayment?.id);
    const eventMatchPaymentIds = _.concat(groupOneMatchPaymentIds, groupTwoMatchPaymentIds);
    const combinedIds = _.concat(eventMatchPaymentIds, _.map(previousState.matchRows, (r) => r.id));
    // const combinedIds = _.map(previousState.matchRows, (r) => r.id);
    // console.log(combinedIds);
    _.map(combinedIds, (id) => {
      const selected = _.includes(selectedMatchIds, id);
      const amount = _.find(this.props.paymentEvents.paymentEventsById, (p) => p.groupOneMatchPayment?.id)?.groupOneMatchPaymentAmount || _.find(this.props.paymentEvents.paymentEventsById, (p) => p.groupTwoMatchPayment?.id)?.groupTwoMatchPaymentAmount;
      rows[id] = { ...previousState.matchRows[id], selected, amount };
    });
    return rows;
  }

  handleSelectAllRows = (): void => {
    this.setState((previousState) => {
      const selectionValue = !this.state.selectedAllRows;
      const selectedRows = this.selectAllRows(previousState.matchRows, selectionValue);
      const matchRows = this.calculateRows(previousState, this.selectedMatchIds(selectedRows));
      return {
        changed: true,
        changedSelectedRow: false,
        selectedAllRows: !previousState.selectedAllRows,
        matchRows,
      };
    });
  }

  selectAllRows = (matchRows, selectionValue = !this.state.selectedAllRows): any => {
    const selectedRows = {};

    _.map(matchRows, (value, key) => {
      selectedRows[key] = {
        selected: selectionValue,
      };
    });

    return selectedRows;
  };

  removeRow = (id): void => {
    this.setState((prevState) => {
      const selectedRows = {
        ...prevState.selectedRows,
        [id]: false,
      };

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  removeAllRows = (rows): void => {
    this.setState((prevState) => {
      const selectedRows = {};

      _.map(rows, (row) => {
        selectedRows[row.id] = false;
      });

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  selectedMatchIds = (matchRows): string[] => _.compact(_.map(matchRows, (row, key) => {
    if (row.selected) {
      return key;
    }
  }))

  selectedMatches = (matchRows: { [index: string]: IMatchRow }): IMatchRow[] => _.compact(_.map(matchRows, (row) => {
    if (row.selected) {
      return row;
    }
    return null;
  }))

  numberOfSelectedMatches = (matchRows = this.state.matchRows): number => this.selectedMatchIds(matchRows).length

  handleBack = () => {
    history.push('/list-payments');
  };

  amountTotal = (): number => {
    const amount = _.sum(_.map(this.selectedMatches(this.state.matchRows), (match) => match?.amount));
    return amount;
  }

  isValid = (): boolean => _.isEmpty(this.state.errors);

  handleSubmit = (e) => {
    e.preventDefault();
    if (
      this.isValid()
      && !this.props.bulkMatchPayments.isLoading
    ) {
      const payload = {
        matchPayments: _.map(this.selectedMatchIds(this.state.matchRows), (o) => ({ id: o })),
      };
      this.props.actions.createBulkMatchPayment(payload);
    }
  }

  render(): React.ReactNode {
    const groupIds = this.groupIds();
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Matches"
              // subtitleComponent={(
              //   <div className="row">
              //     <div className="col">
              //       <span className="text-grey margin-top-10 ">
              //         Matches must all be within a single organisation
              //       </span>
              //     </div>
              //   </div>
              // )}
            />
          </div>
        </div>
        <div className={classnames('row with-margin-bottom', { 'd-none': !this.noConnectedTeams() })}>
          <div className="col">
            <Notification
              onClick={(): any => history.push('/connect-team')}
            >
              <div className="d-inline-block">
                {!this.hasMultipleTeams() && (<h4>Your team is not connected to an association</h4>)}
                {this.hasMultipleTeams() && (<h4>None of your teams are not connected to an association</h4>)}
                <span className="with-margin-top">
                  Connect to your association so you can manage payments
                  &amp; submit forfeits.
                  {' '}
                  <Link className="primary" to="/connect-team">
                    Connect now &gt;
                  </Link>
                </span>
              </div>
            </Notification>
          </div>
        </div>
        <div className={classnames('row with-margin-bottom', { 'd-none': !this.noConnectedTeams() })}>
          <div className="col">
            <Notification
              onClick={(): any => history.push('/connect-team')}
            >
              <div className="d-inline-block">
                {!this.hasMultipleTeams() && (<h4>Your team is not connected to an association</h4>)}
                {this.hasMultipleTeams() && (<h4>None of your teams are not connected to an association</h4>)}
                <span className="with-margin-top">
                  Connect to your association so you can manage payments
                  &amp; submit forfeits.
                  {' '}
                  <Link className="primary" to="/connect-team">
                    Connect now &gt;
                  </Link>
                </span>
              </div>
            </Notification>
          </div>
        </div>
        <div className={classnames('row')}>
          <div className="col">
            <MatchesTableSelectable
              paymentEventIds={this.props.paymentEvents.paymentEventIds}
              paymentEventsById={this.props.paymentEvents.paymentEventsById}
              pagination={this.props.paymentEvents.pagination}
              isLoading={this.props.paymentEvents.isLoading}
              teamPaymentRequests={this.props.teamPaymentRequests}
              aggressiveLoader
              groupIds={groupIds}
              showPayMultipleMatchesButton
              groupsById={this.props.groups.groupsById}
              appReady={this.props.appReady}
              selectTeam={this.props.actions.selectTeam}
              actions={this.props.actions}
              selectRow={this.selectRow}
              selectedRows={this.state.selectedRows}
              selectedRowIds={this.state.selectedRowIds}
              selectedAllRows={this.state.selectedAllRows}
              selectAllRows={this.handleSelectAllRows}
              removeRow={this.removeRow}
              removeAllRows={this.removeAllRows}
              updateSelectedRows={this.updateSelectedRows}
              rows={this.state.matchRows}
            />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            Paying a total of
            {' '}
            <span className="text-weight-bold">{parseAmount(this.amountTotal())}</span>
          </div>
          <div className="col btn-flex-group">
            <div className="btn-flex-container">
              <Button
                className="btn-standard btn-1"
                type="submit"
                noLoading
                disabled={_.filter(this.state.matchRows, 'selected').length === 0}
                onClick={this.handleSubmit}
              >
                Next
              </Button>
              <Button onClick={this.handleBack} className="btn-standard btn-2">Back</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
